import { Dropdown } from "react-bootstrap";
import styles from "./OrganizationDropdown.module.css";
import { useState, useEffect, useContext } from "react";
import { OrganizationContext } from "../../contexts/OrganizationContextProvider";
import { updateCurrentOrganization } from "../../api/Api";
import { showToast } from "../../utils/toastUtils";
import { ProjectContext } from "../../contexts/ProjectContextProvider";
import CustomAvatar from "../ui/CustomAvatar";
import { useUser } from "../../contexts/UserContextProvider";
import CustomButton from "../CustomButton";
import { useNavigate } from "react-router-dom";
import { SiAwsorganizations } from "react-icons/si";
import CancelIcon from '@mui/icons-material/Cancel';
import CreateAnOrganization from "../modals/CreateAnOrganization";

function OrganizationDropdown({ className = "" }) {
  const { data, refresh } = useContext(OrganizationContext);
  const { refresh: refreshProjects } = useContext(ProjectContext);
  const { userInfo, logout } = useUser();
  const [organizationList, setOrgList] = useState([]);
  const [currentOrganization, setCurrentOrganization] = useState(null);
  const [open, setOpen] = useState(false); // for create new organization modal
  const handleClose = () => setOpen(false); // close create new organization modal
  const handleCreateOrg = () => setOpen(true); // open create new organization modal
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const handleOrgChange = (orgId) => () => {
    // implement backend call to change organization
    updateCurrentOrganization(orgId)
      .then((response) => {
        if (response?.status === 200) {
          console.log("Organization changed successfully");
          showToast("Organization changed", "success");
          refresh();
          refreshProjects();
          navigate("/home"); // redirect to dashboard after changing organization
        }
      })
      .catch((error) => {
        console.error("Failed to change organization:", error);
        showToast(
          error.response?.data?.message || "Failed to change organization",
          "error"
        );
      });

    // update the selected organization in the UI
    setOrgList((prevOrgList) =>
      prevOrgList.map((org) => ({
        ...org,
        selected: org.id === orgId,
      }))
    );
  };

  // update the organization list and current organization when data changes
  useEffect(() => {
    setOrgList(data?.organization_list || []);
    setCurrentOrganization(data?.current_organization || null);
    console.log("data", data);
  }, [data]);

  // organization dropdown for the navigation bar also the pop window for creating a new organization
  return (
    <>
      <Dropdown id="od" align="end" className={`${styles.icon} ${className}`}>
        {/* The icon which is shown on the nav bar */}
        <Dropdown.Toggle
          variant="transparent"
          id="dropdown-button-drop-down-centered"
          className="d-flex justify-content-between align-items-center"

        >
          <CustomAvatar user={{ first_name: userInfo?.name }} />
        </Dropdown.Toggle>

        {/* The dropdown menu */}
        <div className={styles.dropdownMenu}>
          <Dropdown.Menu
            style={{ minWidth: "300px" }}
            className="rounded-4 overflow-hidden"
          >
            <div className="d-flex text-center">
              <div
                className="p-3 p4 fw-semibold text-center d-flex justify-content-between align-items-center w-100 position-relative"
                style={{ background: "#DBF2FF" }}
              >
                <div></div> 
                {currentOrganization?.name}
                <CancelIcon onClick={()=>document.getElementById("od").click()} size={28} className={styles.cancelIcon}/>
              </div>
            </div>

            <div className="d-flex flex-column gap-1 p-3 pt-2">

              {/* user info */}
              <div
                className={`${styles.box} d-flex flex-column align-items-center rounded-3 p-3`}
                onClick={() => navigate("/userProfile")}
              > 
                <div >
                  <CustomAvatar
                    user={{ first_name: userInfo?.name }}
                    size={75}
                    fontSize={25}
                    className={styles.avatar}
                  />
                </div>
                <div className="p4 fw-semibold text-capitalize">
                  {userInfo?.name}
                </div>
                <div className="p7 fw-normal text-secondary">
                  {userInfo?.email}
                </div>
              </div>

              {/* organization list */}
              {organizationList.length > 0  && <div className={`${styles.box} rounded-3 overflow-hidden px-2`}>
                {organizationList.map((org) => (
                  <div
                    className={`${styles.orgItem} p6 text-secondary d-flex align-items-center gap-2`}
                    key={org?.id}
                    onClick={handleOrgChange(org?.id)}
                  >
                    <OrganizationIcon size={12}/>
                    {org.name}
                    {/* show the default organization badge if the organization is a default organization */}
                    {org.is_default && (
                      <span
                       className="badge ms-auto p-1 px-2"
                       style={{ backgroundColor: "#d4f3ff", color: "#50c5f3" }}
                       title="Default Organization"
                       >Default</span>
                    )}
                  </div>
                ))}
              </div>}

              {/* Create Organization button */}
              <CustomButton
                variant={styles.createOrgButton}
                className="p-2 p6 text-secondary rounded-3"
                onClick={handleCreateOrg}
              >
                + Create New Organization
              </CustomButton>

              {/* logout button */}
              <CustomButton
                className="mt-1 p-2"
                onClick={handleLogout} // log out button
              >
                Log Out
              </CustomButton>
            </div>
          </Dropdown.Menu>
        </div>
      </Dropdown>
      <CreateAnOrganization show={open} handleClose={handleClose} />
    </>
  );
}

export default OrganizationDropdown;

export const OrganizationIcon = ({ size = 14, className = "", style = {} }) => {
  return (
    <div
      className={`${styles.orgIcon} d-flex align-items-center rounded-5 p-1`}
      style={style}
    >
      <SiAwsorganizations size={size} />
    </div>
  );
};
